import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from '@app/service/common.service';
import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

declare var daum: any;

@Component({
  selector: 'app-contents',
  templateUrl: './contents.component.html',
  styleUrls: ['./contents.component.scss']
})
export class ContentsComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public menu: any;
  public active_seq = '';

  public tabIndex: any = 0;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.currMenu$.subscribe( ( menu: any ) => {
      if( typeof menu['seq'] == 'undefined' ) return false;

      // // 다음맵 로딩
      // if( menu.seq == '374' ) {
      //   setTimeout( () => {
      //     new daum.roughmap.Lander({
      //       "timestamp" : "1591357115839",
      //       "key" : "yoop",
      //       "mapWidth" : "100%",
      //       "mapHeight" : "360"
      //     }).render();
      //   }, 1000);
      // }

      const page = ( menu.page_cd ) ? menu.page_cd : '0';

      switch (page.length) {
        case 12:
          this.active_seq = menu.parentNode.seq;
          this.menu = menu.parentNode;
          break;
        default:
          this.active_seq = menu.seq;
          this.menu = menu;
          break;
      }

    });
  }

  /*******************************************************************************
    설  명 : 서브메뉴 링크
    입력값 : item = 메뉴 array
    리턴값 : 없음
  *******************************************************************************/
  goLink( menu ) {

    let href = menu.link_url;
    let boardId = menu.board_id;
    let menuIndex = menu.seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu);
    }

    if ( boardId === '' ) {
      this.router.navigate([ href ], { queryParams: { menu_seq: menuIndex }});
    } else {
      this.router.navigate([ (href !== '' ? href : '/board/list') ], { queryParams: { board_id: boardId } });
    }
  }

  /*******************************************************************************
    설  명 : 패스 리스트
    입력값 : 없음
    리턴값 : string html
  *******************************************************************************/
  getPathName( item, html ) {
    if( typeof item['parentNode'] == 'undefined' ) return html;
    else {
      html = '<span style="padding:0px 14px;">></span><span class="depth1">' + item['page_menu_name'] + '</span>' + html;
      return this.getPathName( item['parentNode'], html );
    }
  }

  getPath( item ) {
    let html = this.getPathName( item, '' );

    return html;
  }

  /*******************************************************************************
    설  명 : 현재 단계가 4단계 이고, 3단계에 여러 메뉴가 있을 경우
    입력값 : item
    리턴값 : true / false
  *******************************************************************************/
  checkForceLevel( item: any ) {
    if( item.page_cd.length == 12 && item.parentNode.children.length > 1 ) {
      return true;
    } else {
      return false;
    }
  }

}
